import usePrevious from './usePrevious';

const useComparePrevious = value => {
  const prev = usePrevious(value);

  return prev !== value;
};

export default useComparePrevious;
